import { z } from 'zod';
// Canonical source of the STORED user account lifecycle (users.status) — the
// single guest list the DB CHECK + backend logic validate against (ADR-009
// single-source rule, same pattern as LanguageSchema / NumeralsSchema).
//
// DISTINCT from the DERIVED display status in users/responses.ts
// (UserStatusSchema: active | pending | locked | disabled) which layers transient
// signals (lockout, must-change-password) on top of this lifecycle for the wire.
//   · 'active'             — the account may authenticate.
//   · 'pending_activation' — exists but unauthorized: JIT-provisioned via SSO
//                            (ADR-003 §Federated identity / ADR-053), awaiting a
//                            sysadmin to activate. Blocked from authenticating.
//   · 'disabled'           — soft-deleted / deactivated. Blocked from authenticating.
//
// The DATABASE mirrors this set in a CHECK constraint — keep in sync when adding
// a value:
//   backend/migrations/002_federated_identity.sql · chk_users_status
// (SQL can't import this module; the migration comment points back here.)
export const USER_LIFECYCLE_STATUSES = ['active', 'pending_activation', 'disabled'];
export const UserLifecycleStatusSchema = z.enum(USER_LIFECYCLE_STATUSES);
